<template>
  <div v-if="asyncDataStatus_ready">
    <v-card>
      <div class="flex-grow-1 px-2">
        <div class="title-bar d-flex justify-space-between" style="flex-wrap: wrap">
          <div>
            <div class="title">
              {{businessUnit.name}} ({{businessUnit.business_premise_id}})
            </div>
            <div class="subtitle">
              {{fullAddress}}
            </div>
            <div class="subtitle">
              Datum Registracije: {{businessUnit.register_date | sloDateTime}}
            </div>
          </div>
          <div class="actions">
            <ButtonActionEdit @click="$emit('edit')" />
            <ButtonActionDelete @click="$emit('delete')" />
            <ButtonActionDevices @click="$emit('devices')" />
            <ButtonActionInvoices @click="$emit('invoices')" />
          </div>
        </div>
        <v-card-text>
          <v-row>
            <div class="user-card-label">
              ID poslovne enote:
            </div>
            <div class="user-card-value text-right">
              <span>{{ businessUnitId }}</span>
            </div>
          </v-row>
          <v-row>
            <div class="user-card-label">
              Prijavljen na FURS:
            </div>
            <div class="user-card-value">
              <ActiveIcon :value="isRegistered" />
              <v-btn
                class="float-right"
                color="#0F998E"
                dark
                small
                @click="$emit('toggleRegistered')"
              >
                {{isRegistered ? 'Odjavi' : 'Prijavi'}}
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-2">
            <div class="user-card-label">
              Delovni čas:
            </div>
            <div class="user-card-value">
              <ActiveIcon :value="enabledWorkTime" />
              <v-btn
                dark
                class="float-right"
                color="#0F998E"
                small
                @click="$emit('toggleDelovniCas')"
              >
                {{enabledWorkTime ? 'Izklop' : 'Vklopi'}}
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-2">
            <div class="user-card-label">
              Naročila:
            </div>
            <div class="user-card-value">
              <ActiveIcon :value="enabledOrdering" />
              <v-btn
                dark
                class="float-right"
                color="#0F998E"
                small
                @click="$emit('toggleOrdering')"
              >
                {{enabledOrdering ? 'Izklop' : 'Vklopi'}}
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-2">
            <div class="user-card-label">
              Mize:
            </div>
            <div class="user-card-value">
              <ActiveIcon :value="enabledTables" />
              <v-btn
                dark
                class="float-right"
                color="#0F998E"
                small
                @click="$emit('toggleTables')"
              >
                {{enabledTables ? 'Izklop' : 'Vklopi'}}
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-2">
            <div class="user-card-label">
              Nivoji cen:
            </div>
            <div class="user-card-value">
              <ActiveIcon :value="enabledPricing" />
              <v-btn
                dark
                class="float-right"
                color="#0F998E"
                small
                @click="$emit('togglePricing')"
              >
                {{enabledPricing ? 'Izklop' : 'Vklopi'}}
              </v-btn>
            </div>
          </v-row>
          <v-row class="mt-2" style="align-items:center;">
            <div class="user-card-label" style="flex:1;">
              Blagajna za tiskanje:
            </div>
            <div class="user-card-value" style="flex:0;">
              <v-select
                v-model="currentSelectedPrintingDevice"
                item-text="name"
                :items="availableDevices"
                return-object
                @input="onSelectionChanged">>
              </v-select>
            </div>
          </v-row>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ButtonActionDevices from './ButtonActionDevices'
import ButtonActionInvoices from './ButtonActionInvoices'
import { objectToArray } from '@/utils/object'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ActiveIcon from './ActiveIcon'
import { mapActions } from 'vuex'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionDevices,
    ButtonActionInvoices,
    ActiveIcon
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    businessUnit: {
      required: true,
      type: Object
    },
    childCompanyId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      showActivateBusinessUnitModal: false,
      activateBusinessUnitNotes: '',
      availableDevices: [],
      currentSelectedPrintingDevice: ''
    }
  },
  computed: {
    cityString () {
      if (this.businessUnit.post_code && this.businessUnit.city) return `${this.businessUnit.post_code}, ${this.businessUnit.city}`
      if (this.businessUnit.city) return this.businessUnit.city
      if (this.businessUnit.post_code) return this.businessUnit.post_code
      return ''
    },
    businessUnitId () {
      return this.businessUnit.id
    },
    fullAddress () {
      if (this.businessUnit.address && this.cityString) { return this.businessUnit.address + ', ' + this.cityString }
      if (this.businessUnit.address) { return this.businessUnit.address }
      return 'Ni naslova'
    },
    isRegistered () {
      return this.businessUnit.register_date !== null
    },
    enabledWorkTime () {
      return this.businessUnit.work_time
    },
    enabledOrdering () {
      return this.businessUnit.ordering
    },
    enabledTables () {
      return this.businessUnit.table_work
    },
    enabledPricing () {
      return this.businessUnit.pricing
    }
  },
  methods: {
    ...mapActions('clientsBusinessUnits', ['toggleRegistered']),
    ...mapActions('clientsDevices', ['loadItems', 'saveItem']),
    onSelectionChanged (data) {
      this.saveItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnit.id, item: { ...data, is_print: true } })
    },
    loadDevices () {
      this.loadItems({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnit.id })
        .then(items => {
          this.availableDevices = objectToArray(items)
          this.currentSelectedPrintingDevice = this.availableDevices.find(device => device.is_print)
          this.asyncDataStatus_fetched()
        })
    },
    setRegistered () {
      const data = {
        id: this.businessUnit.id,
        special_notes: this.activateBusinessUnitNotes,
        close: !this.isRegistered
      }
      this.toggleRegistered({ childCompanyId: this.childCompanyId, data })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    }
  },
  created () {
    this.loadDevices()
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      min-width: 60px;
      max-width: 60px;
      margin-left: 15px;
      justify-content: flex-end;
    }
  }

  /* .hr-breakpoint-mobile {

  } */

  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .user-card-label {
      min-width: 120px;
      color: #BDBDBD;
    }
    .user-card-value {
      min-width: 160px;
      color: #607D8B;
      font-weight: bold;
    }
  }
</style>
